export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13860.e6546f93.jpg";